import type { TRuleWithTheme } from '@ackee/fela';

import playButton from '../../../../../static/images/video/playButton.svg';
import playButtonHover from '../../../../../static/images/video/playButtonHover.svg';

export const button: TRuleWithTheme<{ shouldShow: boolean; large: boolean }> = ({ shouldShow, large }) => ({
    width: '5rem',
    height: '5rem',
    backgroundImage: `url(${playButton})`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',

    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    cursor: 'pointer',
    opacity: shouldShow ? 1 : 0,
    transition: 'opacity, ease-in-out, 0.3s',

    ...(large
        ? {
              tablet: {
                  width: '15rem',
                  height: '15rem',
                  backgroundSize: 'auto',
              },
          }
        : null),

    ':hover': {
        backgroundImage: `url(${playButtonHover})`,
    },
});
